import { ProcessTypeV3x1 } from '../../../../api/generated/cz.partners.pid.backofficegateway.pidonboarding';

const BANK_ID_TYPES = [
	ProcessTypeV3x1.BANK_ID_ONBOARDING,
	ProcessTypeV3x1.BANK_ID_ACTIVATION,
] as const;

type BankIdProcessType =
	| typeof ProcessTypeV3x1.BANK_ID_ONBOARDING
	| typeof ProcessTypeV3x1.BANK_ID_ACTIVATION;

export const checkIsBankIdType = (
	type: ProcessTypeV3x1,
): type is BankIdProcessType => {
	return BANK_ID_TYPES.some((bankIdType) => bankIdType === type);
};
